import React, { Component } from 'react';
import cn from 'classnames';
import s from './style';
import tracker from '../../../services/tracker';
import { withTranslation } from 'react-i18next';
import FormTechnicalProblem from 'components/Login/FormTechnicalProblem/FormTechnicalProblem';
import { ROOT_URL } from '../../../constants/Config';
import axios from 'axios';

const tariffs = [
  { id: 1, name: 'tarifSolo', months: 1, price: '1 999 ₽' },
  {
    id: 106,
    name: 'tarifSolo',
    months: 3,
    price: '4 999 ₽',
    fullPrice: '6 999 ₽',
    pricePerMonth: '1 666 ₽/мес',
    discount: '-17%',
  },
  {
    id: 51,
    name: 'tarifSolo',
    months: 12,
    price: '16 999 ₽',
    fullPrice: '23 999 ₽',
    pricePerMonth: '1 416 ₽/мес',
    discount: '-33%',
    label: 'popular',
  },
];

class PayForTarif extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showError: false,
      selectedTarif: null,
    };
  }

  handlePayClick = async () => {
    tracker.sendEvent('Web_Profile_Renew_Subscription');

    const newWindow = window.open('about:blank', '_blank');

    if (!newWindow) {
      this.setState({ showError: true });
      return;
    }

    try {
      const response = await axios.post(`${ROOT_URL}/payments`, {
        tariffId: this.state.selectedTarif,
      });
      const { confirmationUrl } = response.data.data;

      newWindow.location.href = confirmationUrl;
    } catch (error) {
      console.error(error);
      this.setState({ showError: true });
      newWindow.close();
    }
  };

  showRequestForm = () => {
    this.props.showRequestForm();
  };

  selectTarif = (tariffId) => {
    this.setState({ selectedTarif: tariffId });
  };

  render() {
    const { t } = this.props;
    const { showError, selectedTarif } = this.state;
    return (
      <div className={s.TarifPay}>
        {showError && (
          <FormTechnicalProblem handleCloseModal={() => this.setState({ showError: false })} />
        )}
        <div className={s.TarifPayHead}>{t('components.payments.payForTarif.title')}</div>
        <div className={s.TarifPaySubtitle}>{t('components.payments.payForTarif.subtitle')}</div>
        <div className={s.Tarifs}>
          {tariffs.map((item) => (
            <div
              key={item.id}
              className={cn(s.TarifCard, { [s.selected]: selectedTarif === item.id })}
              onClick={() => this.selectTarif(item.id)}
            >
              {item.label && (
                <div className={s.Label}>{t(`components.payments.payForTarif.${item.label}`)}</div>
              )}
              <div className={s.TarifCardTitle}>
                <div className={s.TarifCardName}>
                  {t(`components.payments.payForTarif.${item.name}`)}
                </div>
                <div className={s.TarifCardMonths}>
                  {t(`components.payments.payForTarif.months.${item.months}`)}
                </div>
              </div>
              <div className={s.Content}>
                <div className={s.ContentPrice}>
                  <div className={s.Price}>{item.price}</div>
                  <div className={s.FullPrice}>{item.fullPrice}</div>
                </div>
                <div className={s.ContentRight}>
                  {item.discount && <div className={s.Discount}>{item.discount}</div>}
                  {item.pricePerMonth && (
                    <div className={s.PricePerMonth}>{item.pricePerMonth}</div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={s.TarifCardFooter}>
          <button
            className={cn(s.FooterButton, 'button-primary', 'button-primary--md')}
            onClick={this.handlePayClick}
            disabled={!selectedTarif}
          >
            {t('components.payments.payForTarif.button')}
          </button>
        </div>
      </div>
    );
  }
}

export default withTranslation()(PayForTarif);



// WEBPACK FOOTER //
// ./src/components/Payments/PayForTarif/PayForTarif.js